import { formatDistanceToNow } from "date-fns";
import { ko } from "date-fns/locale";

export function formatRelativeTimeKo(
  value: unknown,
  fallback = "날짜 정보 없음",
): string {
  if (
    value === null ||
    value === undefined ||
    (typeof value === "string" && value.trim() === "")
  ) {
    return fallback;
  }

  const date = value instanceof Date ? value : new Date(String(value));
  if (!Number.isFinite(date.getTime())) return fallback;

  return formatDistanceToNow(date, { addSuffix: true, locale: ko });
}
